import React, {Component} from 'react';
import {Grid, Row, Col} from "react-bootstrap";
import TopBreadcumb from "../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../shared/sidebar/SidebarComponent";
import Links from "../../../utilities/linksConfig/Links";
import {TopButtonAction} from "../../../componentsTopsa/buttons/TopButtons";
import SynchronizacjaService from "./SynchronizacjaService";

export default class SynchronizacjaDanychContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            czyWyslano: false,
            czyTrwaWysylanie: false,
            czyKliknietoWyslij: false
        };
        this.onClickWyslijDaneSprzedazyDoKsiegowosci = this.onClickWyslijDaneSprzedazyDoKsiegowosci.bind(this)
    }

    onClickWyslijDaneSprzedazyDoKsiegowosci() {
        if (window.confirm('Czy na pewno wysłać dane do księgowości?')) {
            this.setState({
                czyWyslano: false,
                czyTrwaWysylanie: true,
                czyKliknietoWyslij: true
            })
            SynchronizacjaService.wyslijDaneSprzedazyDoFK().then(function (response) {

                if (response) {
                    if (response.status < 300) {
                        this.setState({
                            czyWyslano: true,
                            czyTrwaWysylanie: false
                        })
                    }
                    else {
                        this.setState({
                            czyWyslano: false,
                            czyTrwaWysylanie: false
                        })
                    }
                } else {
                    this.setState({
                        czyWyslano: false,
                        czyTrwaWysylanie: false
                    })
                }

            }.bind(this)).catch(function (err) {
                if(err){
                    this.setState({
                        czyWyslano: false,
                        czyTrwaWysylanie: false
                    })
                }
            }.bind(this))
        }
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>

                <Grid fluid={true} id={'AdministracjaContainer'}>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/administracja', text: 'Administracja'}, {
                                    addressUrl: '/administracja/synchronizacja',
                                    text: 'Synchronizacja danych'
                                }]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className={'thumbnail'} style={{padding: '30px', margin: '15px 0'}}>
                                <Row>
                                    <Col xs={8}>
                                        <h2>Synchronizacja danych sprzedaży biletów</h2>
                                        <p style={{fontSize: '18px', color: 'grey'}}>
                                            Kliknięcie przycisku po prawej stronie powoduje wysyłkę danych dotyczących sprzedaży biletów.
                                            Dane wysyłane są do tabeli FK aby były widoczne dla księgowości.
                                        </p>
                                    </Col>
                                    <Col xs={4}>
                                        <div className={'pull-right'} style={{marginTop: '50px'}}>
                                            {
                                                Boolean(this.state.czyKliknietoWyslij) ?
                                                    <div>
                                                        {
                                                            Boolean(this.state.czyTrwaWysylanie) ?
                                                                <div id={'smallLoader'} style={{margin: 0}}>
                                                                    <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                                                    <div>Trwa wysyłanie...</div>
                                                                </div>
                                                                :
                                                                <div>
                                                                    {
                                                                        Boolean(this.state.czyWyslano)?
                                                                            <h4>
                                                                                <i className={'fa fa-check'} style={{color:'forestgreen', fontSize:'24px'}}></i> Wysłano pomyślnie dane
                                                                            </h4>
                                                                            :
                                                                            <h4>
                                                                                <i className={'fa fa-times'} style={{color:'firebrick', fontSize:'24px'}}></i> Wystąpił błąd - dane nie zostały wysłane
                                                                            </h4>
                                                                    }
                                                                    <a onClick={()=>{this.setState({czyKliknietoWyslij:false})}}
                                                                       style={{cursor:'pointer', marginLeft:'30px'}}
                                                                    >Powrót</a>
                                                                </div>
                                                        }
                                                    </div>
                                                    :
                                                    <TopButtonAction onClick={this.onClickWyslijDaneSprzedazyDoKsiegowosci}
                                                                     text={'Wyślij dane sprzedaży do księgowości'}
                                                                     iconType={'fa fa-share-square-o'}
                                                                     btnSize={'lg'}
                                                                     btnColor={'warning'}
                                                    />
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </SidebarComponent>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/synchronizacjaDanych/SynchronizacjaDanychContainer.js